<template>
  <form class="relative" @submit.prevent="$emit('submit')">
    <input :value="modelValue" :placeholder="placeholder"
      class="h-13 w-full rounded-lg border border-border bg-card ps-12 pe-5 text-[15px] text-foreground placeholder:text-muted-foreground outline-none transition-shadow focus:ring-2 focus:ring-primary"
      @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)" />
    <button type="submit" aria-label="جستجو"
      class="absolute start-1.5 top-1/2 -translate-y-1/2 grid h-9 w-9 place-items-center cursor-pointer rounded-full text-muted-foreground hover:bg-secondary">
      <svg xmlns="http://www.w3.org/2000/svg" class="rotate-90" width="13" height="13" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="7" />
        <path d="m20 20-4-4" />
      </svg>
    </button>
  </form>
</template>

<script setup lang="ts">
defineProps<{ modelValue?: string; placeholder?: string }>()
defineEmits<{ 'update:modelValue': [value: string]; submit: [] }>()
</script>
